import React from 'react';
import { useRecoilValue } from 'recoil';
import { blockLimitedRequestSubjects } from 'venn-state';
import { StyledErrorState } from '../StyledErrorState';
import type { ErrorWrapper } from './errorWrapperTypes';

export const TaxImpactErrorWrapper: ErrorWrapper = ({ blockId, children }) => {
  const subjects = useRecoilValue(blockLimitedRequestSubjects(blockId));

  if (subjects.length < 2) {
    return (
      <StyledErrorState
        selectedRefId={blockId}
        header="Your Subject Group must include two portfolios with tax information"
        message="Please configure the subjects"
      />
    );
  }

  return children;
};
